<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells><h2 class="title">Products</h2></app-cells>
      <div class="info-row">
        <div class="info-row__item">
          <div class="info-row__content">
            <span class="info-row__value">{{ products_data.total_value_tsh.toLocaleString() }}</span>
            <span class="info-row__text">Total value TSh</span>
          </div>
        </div>
        <div class="info-row__item">
          <div class="info-row__content">
            <span class="info-row__value">{{ products_data.total_value_usd.toLocaleString() }}</span>
            <span class="info-row__text">Total value USD</span>
          </div>
        </div>
        <div class="info-row__item">
          <div class="info-row__content">
            <span class="info-row__value">{{ products_data.total_products.toLocaleString() }}</span>
            <span class="info-row__text">Products on balance</span>
          </div>
        </div>
      </div>
      <app-cells><h2 class="title">Suppliers</h2></app-cells>
      <div class="info-row">
        <div class="info-row__item">
          <div class="info-row__content">
            <span class="info-row__value">{{ suppliers_data.pay_by_cash.toLocaleString() }}</span>
            <span class="info-row__text">Pay by cash</span>
          </div>
        </div>
        <div class="info-row__item">
          <div class="info-row__content">
            <span class="info-row__value">{{ suppliers_data.pay_by_bank.toLocaleString() }}</span>
            <span class="info-row__text">Pay by bank</span>
          </div>
        </div>
        <div class="info-row__item">
          <div class="info-row__content">
            <span class="info-row__value">{{ suppliers_data.unpaid_values.total_value.toLocaleString() }}</span>
            <span class="info-row__text">Unpaid value TSh</span>
          </div>
        </div>
        <div class="info-row__item">
          <div class="info-row__content">
            <span class="info-row__value">{{ suppliers_data.unpaid_values.total_value_usd.toLocaleString() }}</span>
            <span class="info-row__text">Unpaid value USD</span>
          </div>
        </div>
      </div>
      <app-cells>
        <h1 class="title">Products price</h1>
        <div class="date-picker-wrapper">
          <VueCtkDateTimePicker
            id="date_picker_balance"
            class="custom-date-time-picker custom-date-time-picker--range"
            v-model="filter_dates"
            :custom-shortcuts="custom_shortcuts"
            shortcut="last30Days"
            @is-hidden="onIsHiddenPicker"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select dates"
            color="#77b017"
            button-color="#77b017"
            overlay
            no-header
            no-label
            locale="en"
            range
            noClearButton
          />
          <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
        </div>
      </app-cells>
      <app-grid>
        <template #item-1>
          <app-cells><h2 class="title">Price increase</h2></app-cells>
          <v-client-table
            :data="table.items"
            :columns="table.columns"
            :options="table.options"
            class="table-default"
          >
            <template #h__product.name>
              <div class="table-default__left">Product name</div>
            </template>
            <template #product.name="{ row }">
              <div class="table-default__left">
                <router-link :to="{name: 'product-storage-products-detail', params: {id: row.product.id }}" class="table-default__link-border">
                  {{ row.product.name }}
                </router-link>
              </div>
            </template>
            <template #from_value="{ row }">
              {{ row.from_value.toLocaleString() }} TSh
            </template>
            <template #to_value="{ row }">
              {{ row.to_value.toLocaleString() }} TSh
            </template>
            <template #percent="{ row }">
              <span class="table-default__text-red">{{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 1}).format(row.percent) }}</span>
            </template>
          </v-client-table>
        </template>
        <template #item-2>
          <app-cells><h2 class="title">Price decrease</h2></app-cells>
          <v-client-table
            :data="table2.items"
            :columns="table2.columns"
            :options="table2.options"
            class="table-default"
          >
            <template #h__product.name>
              <div class="table-default__left">Product name</div>
            </template>
            <template #product.name="{ row }">
              <div class="table-default__left">
                <router-link :to="{name: 'product-storage-products-detail', params: {id: row.product.id }}" class="table-default__link-border">
                  {{ row.product.name }}
                </router-link>
              </div>
            </template>
            <template #from_value="{ row }">
              {{ row.from_value.toLocaleString() }} TSh
            </template>
            <template #to_value="{ row }">
              {{ row.to_value.toLocaleString() }} TSh
            </template>
            <template #percent="{ row }">
              <span class="table-default__text-green">{{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 1}).format(row.percent) }}</span>
            </template>
          </v-client-table>
        </template>
      </app-grid>

    </template>
  </div>
</template>

<script>
import {
  getProductStorageGeneralPricesAnalytics,
  getProductStorageGeneralProductsAnalytics,
  getProductStorageGeneralSuppliersAnalytics,
} from '@/http'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  name: 'ProductStorageAnalyticsOrders',
  components: { VueCtkDateTimePicker },
  data() {
    return {
      is_loaded: false,
      products_data: {},
      suppliers_data: {},
      filter_dates: null,
      custom_shortcuts: [
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'thisYear', label: 'This year', value: 'year' },
      ],
      date_picker_error: false,
      table: {
        items: [],
        columns: ['product.name', 'product.measurement.name', 'from_value', 'to_value', 'percent'],
        options: {
          headings: {
            'product.name': 'Product name',
            'product.measurement.name': 'Unit',
            'from_value': 'From (TSh)',
            'to_value': 'To (TSh)',
            'percent': 'Percent',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 150,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table2: {
        items: [],
        columns: ['product.name', 'product.measurement.name', 'from_value', 'to_value', 'percent'],
        options: {
          headings: {
            'product.name': 'Product name',
            'product.measurement.name': 'Unit',
            'from_value': 'From (TSh)',
            'to_value': 'To (TSh)',
            'percent': 'Percent',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 150,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    getProductStorageGeneralSuppliersAnalytics()
      .then(response => {
        this.suppliers_data = response.data
        getProductStorageGeneralProductsAnalytics()
          .then(response => {
            this.products_data = response.data
            this.is_loaded = true
            this.$nextTick(() => {
              this.fetchItems()
            })
          })
      })
  },
  methods: {
    fetchItems() {
      getProductStorageGeneralPricesAnalytics(this.filter_dates.start, this.filter_dates.end)
        .then(response => {
          this.table.items = response.data.increase_products
          this.table2.items = response.data.decrease_products
        })
    },
    onIsHiddenPicker() {
      if (this.filter_dates.hasOwnProperty('start') &&
        this.filter_dates.start &&
        this.filter_dates.hasOwnProperty('end') &&
        this.filter_dates.end) {
        this.date_picker_balance_error = false
        this.fetchItems()
      } else this.date_picker_balance_error = true
    },
  }
}
</script>

<style lang="sass">
.date-picker-wrapper
  position: relative

.date-picker-wrapper__error
  position: absolute
  bottom: -18px
  color: $color-error
  font-size: 12px
</style>
